var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar-admin"},[_c('div',{staticClass:"bar-content"},[_c('router-link',{staticClass:"top-bar-logo",attrs:{"to":{name:'dashboard'}}},[_c('BaseLogo',{attrs:{"small-screen":_vm.smallScreen}})],1),(_vm.$store.state.user.isAuthenticated)?_c('MenuAdmin'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }